import { inviteMissionEditor } from '../api/missions';
import { EDITORS_KEY, readStored, writeStored, type DraftEditor } from './newMissionDraft';

/** The members the wizard collected, to add to the mission once it exists; the draft is emptied. */
export async function inviteDraftEditors(code: string): Promise<string[]> {
  const draft = readStored<DraftEditor[]>(EDITORS_KEY) ?? [];
  const failed: string[] = [];
  for (const e of draft) {
    try {
      await inviteMissionEditor(code, e.handle);
    } catch {
      failed.push(e.handle);
    }
  }
  writeStored<DraftEditor[]>(EDITORS_KEY, []);
  return failed;
}
